import { useEffect, forwardRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useSimStore } from '../store/simStore'
import type { Notification } from '../types'

const LEVEL_COLOURS: Record<Notification['level'], string> = {
  info:    'border-teal-500',
  warn:    'border-amber-500',
  error:   'border-rose-500',
  success: 'border-emerald-500',
}

const Toast = forwardRef<HTMLDivElement, { note: Notification }>(({ note }, ref) => {
  const dismiss = useSimStore((s) => s.dismissNotification)
  useEffect(() => {
    const t = setTimeout(() => dismiss(note.id), 5000)
    return () => clearTimeout(t)
  }, [note.id, dismiss])

  return (
    <motion.div
      ref={ref}
      layout
      initial={{ x: 120, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 120, opacity: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className={`bg-[#161b22] border-l-4 ${LEVEL_COLOURS[note.level]} rounded px-3 py-2 text-xs text-slate-200 shadow-xl cursor-pointer max-w-64`}
      onClick={() => dismiss(note.id)}
    >
      {note.message}
    </motion.div>
  )
})

export function NotificationToast() {
  const notifications = useSimStore((s) => s.notifications)
  return (
    <div className="absolute top-16 right-2 z-50 flex flex-col gap-2">
      <AnimatePresence mode="popLayout">
        {notifications.map((n) => <Toast key={n.id} note={n} />)}
      </AnimatePresence>
    </div>
  )
}
